function Renjie() {
  return (
    <div className="renjie">
      <div className="rj" />
      <div className="bio">
        <p>
          Art has always revolved around his early childhood. Renjie began his artistic endeavor as a painter during his young adult years and as an art
          director in his early careers. During his time as an advertising creative, Renjie has crafted numerous campaigns with renowned brands like Google,
          Sony and IBM. Every of his work is visually spectacular yet unique because Renjie pays relentless attention to details. One of his works, ULeChang
          (游乐场), a whimsical themed digital experience, won multiple international accolades.
        </p>
        <p>
          Renjie creates artwork based on intuition that juxtaposes reality with fantasy. His creations are snapshots of influences by the movies, video games
          and music he was exposed to when he was young.
        </p>
      </div>
    </div>
  );
}

export default Renjie;
